export enum QuizQuestionType {
  MULTIPLECHOICE = 1,
  TEXT = 2,
  CKECKBOX = 3,
}
